import { useEffect } from 'react';

import type { Me } from '@/entities/me';

export function useWhiteLabelSync(me: Me | undefined) {
  useEffect(
    function () {
      window.document.body.classList.toggle(
        'white-label',
        me?.whiteLabel === true,
      );
    },
    [me?.whiteLabel],
  );
}
